import React from "react";
import {
  Phone,
  Mail,
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
} from "lucide-react";

const ContactInfoCard = () => {
  const contactInfo = [
    { icon: Phone, text: "+1-971-431-8339", label: "Phone" },
    { icon: Mail, text: "sales@mail.smilereveal.io", label: "Email" },
  ];

  const targetAudience = [
    {
      title: "Dental clinics",
      desc: "boost implant and cosmetic case acceptance",
    },
    {
      title: "Cosmetic dentistry practices",
      desc: "show patients veneer and whitening results",
    },
    {
      title: "Multi-location groups",
      desc: "standardize consultations across offices",
    },
    {
      title: "DSOs",
      desc: "white-label smile simulation for enterprise dental organizations",
    },
  ];

  const socialLinks = [
    { icon: Facebook, href: "https://www.facebook.com/smilereveal" },
    { icon: Instagram, href: "https://www.instagram.com/smilereveal" },
    { icon: Linkedin, href: "https://www.linkedin.com/company/smilereveal" },
    { icon: Twitter, href: "https://twitter.com/smilereveal" },
  ];

  return (
    <div className="bg-white rounded-[2rem] p-8 shadow-sm border border-slate-100 h-full flex flex-col">
      <div className="space-y-8 flex-grow">
        {/* Contact info */}
        <div>
          <h3 className="text-lg font-bold text-slate-900 mb-6">
            Contact SmileReveal™ Sales:
          </h3>
          <div className="space-y-4">
            {contactInfo.map((item, index) => (
              <div key={index} className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
                  <item.icon className="w-5 h-5 text-[#0066ff]" />
                </div>
                <span className="text-slate-600 font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Who We Serve */}
        <div>
          <h3 className="text-lg font-bold text-slate-900 mb-4">
            Who Uses SmileReveal™ AI Smile Simulation:
          </h3>
          <div className="space-y-3">
            {targetAudience.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-3 p-3 bg-white border border-slate-100 rounded-xl shadow-sm"
              >
                <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#0066ff] shrink-0" />
                <p className="text-sm text-slate-600 leading-relaxed">
                  <strong className="text-slate-800">{item.title}</strong> —{" "}
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Follow Us */}
        <div>
          <h3 className="text-lg font-bold text-slate-900 mb-6">Follow Us:</h3>
          <div className="flex gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-[#0066ff] hover:bg-[#0066ff] hover:text-white transition-all duration-300 shadow-sm"
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoCard;
